/**
 * Gravity Forms — floating label behaviour.
 *
 * Adds .gf-float to .gfield when the input is focused or has a value,
 * causing the label to shrink and move up via CSS.
 */
function initFloatingLabels(scope) {
  const fields = (scope || document).querySelectorAll('.gfield');

  fields.forEach((field) => {
    const input = field.querySelector('input:not([type="hidden"]):not([type="checkbox"]), select, textarea');
    if (!input) return;

    const update = () => {
      const hasValue = input.value && input.value.length > 0;
      const isFocused = document.activeElement === input;
      field.classList.toggle('gf-float', hasValue || isFocused);
    };

    input.addEventListener('focus', update);
    input.addEventListener('blur', update);
    input.addEventListener('input', update);
    input.addEventListener('change', update);

    // Initial check (pre-filled fields, browser autofill)
    update();
  });
}

// Init on load
initFloatingLabels();

// Re-init after GF AJAX render (page changes, validation)
document.addEventListener('gform_post_render', () => {
  initFloatingLabels();
});

// Also re-init on DOM ready (for non-AJAX form reloads)
document.addEventListener('DOMContentLoaded', () => {
  initFloatingLabels();
});

// Re-init on window load (catches late-loading forms)
window.addEventListener('load', () => {
  initFloatingLabels();
});

// MutationObserver to catch dynamically added forms
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.addedNodes) {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) { // Element node
          // Check if this node or its children contain forms
          if (node.querySelector && node.querySelector('.gform_wrapper')) {
            setTimeout(() => initFloatingLabels(node), 100);
          }
        }
      });
    }
  });
});

// Start observing the document body
observer.observe(document.body, {
  childList: true,
  subtree: true
});
